import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { http, formatError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters.");
      return;
    }
    if (password !== confirm) {
      toast.error("Passwords don't match.");
      return;
    }
    setLoading(true);
    try {
      await http.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Password updated. You can sign in now.");
      setTimeout(() => nav("/login"), 1500);
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-32 pb-24 min-h-[80vh] flex items-center justify-center" data-testid="reset-password-page">
      <motion.form
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        onSubmit={submit}
        className="glass-panel rounded-lg p-10 w-full max-w-md"
      >
        <div className="text-center mb-8">
          <div className="text-[10px] tracking-[0.35em] uppercase text-pink-blush mb-3">Fresh start</div>
          <h1 className="font-display text-4xl text-champagne">
            Choose a new <span className="italic text-pink-hot">password</span>
          </h1>
        </div>

        {!token ? (
          <div className="text-center text-sm text-champagne/75">
            This reset link looks invalid.{" "}
            <Link to="/forgot-password" className="text-pink-hot pink-underline-link">Request a new one</Link>
          </div>
        ) : done ? (
          <div className="text-center text-sm text-champagne/85">
            All set — redirecting you to sign in...
          </div>
        ) : (
          <div className="space-y-3">
            <input
              required type="password" placeholder="New password (6+)" value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-noir-base border border-rosegold/20 px-4 py-3 text-sm rounded-sm focus:border-pink-hot focus:outline-none text-champagne"
              data-testid="reset-password-new"
            />
            <input
              required type="password" placeholder="Confirm new password" value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="w-full bg-noir-base border border-rosegold/20 px-4 py-3 text-sm rounded-sm focus:border-pink-hot focus:outline-none text-champagne"
              data-testid="reset-password-confirm"
            />
            <button
              disabled={loading}
              className="w-full py-3 bg-pink-hot text-white text-xs tracking-[0.3em] uppercase rounded-sm hover:bg-pink-glow glow-pink transition-all disabled:opacity-60"
              data-testid="reset-submit"
            >
              {loading ? "Updating..." : "Reset password"}
            </button>
          </div>
        )}
      </motion.form>
    </div>
  );
}
